/* !
 * index.js v1.0.0
 * Copyright, Connecty Inc.
 */
((FUNCTIONS) => {
	const a = 'is-active';
	const v = 'is-visible';

	// 申込手続き・アプリ登録方法（タブ＋ステップスライダー）の処理
	const familyChallengeTab = () => {
		const root = document.querySelector('.js-familyChallenge-step');
		if (!root) return;

		const sliderElement = root.querySelector('.js-familyChallenge-slider');
		// data-slide（担当タブの先頭スライド番号）の昇順に並べ替えて保持
		const tabs = Array.from(root.querySelectorAll('.js-familyChallenge-tab'))
			.sort((tab1, tab2) => Number(tab1.dataset.slide) - Number(tab2.dataset.slide));
		if (!sliderElement || !tabs.length) return;

		const splide = new Splide(sliderElement, {
			type: 'fade', // スライドはフェードで切り替える
			rewind: false, // ループさせず先頭・末尾で矢印を非活性にする
			perPage: 1,
			perMove: 1,
			speed: 500,
			arrows: true,
			pagination: false,
			labelledby: 'familyChallengeStepTitle',
			classes: {
				arrows: 'splide__arrows reward-familyChallenge-step_arrows',
				arrow: 'splide__arrow reward-familyChallenge-step_arrow',
				prev: 'splide__arrow--prev _prev',
				next: 'splide__arrow--next _next'
			},
			// Splideが矢印のaria-labelやaria-roledescriptionを既定の英語で上書きするため日本語を指定する
			i18n: {
				prev: '前のステップへ',
				next: '次のステップへ',
				carousel: 'ステップスライダー',
				slide: 'ステップ'
			},
		});

		// 表示中のスライドが属するタブを活性化する
		const switchTab = (_index) => {
			const index = (typeof _index === 'number') ? _index : splide.index;
			// data-slideがindex以下のもののうち、最後のタブが担当タブ
			let current = tabs[0];
			tabs.forEach(tab => {
				if (index >= Number(tab.dataset.slide)) current = tab;
			});
			tabs.forEach(tab => {
				const isCurrent = (tab === current);
				tab.classList.toggle(a, isCurrent);
				// タブパネルを持たない構造のため、aria-selectedではなくaria-currentで現在地を伝える
				(isCurrent) ? tab.setAttribute('aria-current', 'true') : tab.removeAttribute('aria-current');
			});
		};

		tabs.forEach(tab => {
			tab.addEventListener('click', () => {
				// 活性中のタブはタップしても画面遷移しない
				if (tab.classList.contains(a)) return;
				splide.go(Number(tab.dataset.slide));
			});
		});

		// フェード切り替えのため非表示スライドも重なったまま残る
		// （aria-hidden内のリンクにフォーカスが当たらないようinertで無効化する）
		const updateInert = (_index) => {
			const index = (typeof _index === 'number') ? _index : splide.index;
			splide.Components.Slides.forEach((Slide) => {
				(Slide.index === index) ? Slide.slide.removeAttribute('inert') : Slide.slide.setAttribute('inert', '');
			});
		};

		// 先頭・末尾に到達すると矢印がdisabledになりフォーカスがbodyへ抜けてしまう
		// （キーボード操作が途切れないよう表示中のスライドへフォーカスを退避させる）
		const restoreFocus = () => {
			// 矢印の無効化以外でフォーカスが外れている場合は何もしない
			if (document.activeElement && document.activeElement !== document.body) return;
			const arrows = Array.from(root.querySelectorAll('.splide__arrow'));
			if (!arrows.some(arrow => arrow.disabled)) return;
			const Slide = splide.Components.Slides.getAt(splide.index);
			if (!Slide) return;
			// スライド自身はDOM順で矢印より前のため、続けてTabするとスライド内のリンクへ進める
			Slide.slide.setAttribute('tabindex', '-1');
			Slide.slide.focus({ preventScroll: true });
		};

		splide.on('mounted refresh', () => { switchTab(); updateInert(); });
		splide.on('move', (newIndex) => { switchTab(newIndex); updateInert(newIndex); });
		splide.mount();
		// 矢印のdisabled更新（Splide内部のmovedハンドラ）より後に判定する必要があるためmount後に登録する
		splide.on('moved', () => { restoreFocus(); });
	};

	// アンカーリンク（#ID）で遷移してきた場合、該当のアコーディオンを開いた状態で表示する
	// （setting.jsのeaseScrollHashがload後に位置を計算するため、それより前に開いておく）
	const familyChallengeAccordionHash = () => {
		const openAccordion = (_id) => {
			if (!_id) return;
			const target = document.getElementById(_id);
			if (!target) return;
			// ID指定がアコーディオン自身でも、アコーディオン内の要素でも開く
			const details = target.closest('details.js-accordion');
			// ブラウザの自動展開（ハッシュ遷移・ページ内検索）ではopen=""が付き、CSSの[open="true"]に一致しないため値で判定する
			if (!details || details.getAttribute('open') === 'true') return;
			// 開閉時のCSSが[open="true"]を参照しているため、setting.jsのaccordionと同じく値にtrueを指定する
			details.setAttribute('open', 'true');
		};
		openAccordion(location.hash.slice(1));
		// 同一ページ内でハッシュのみ変わった場合にも開く
		window.addEventListener('hashchange', () => { openAccordion(location.hash.slice(1)); });
		// ページ内リンク（rel="scroll"）はsetting.jsのeaseScrollでpreventDefaultされハッシュが変わらないため、クリック時に開く
		// （easeScrollのスクロール位置計算より先に開くよう、キャプチャフェーズで登録する）
		document.addEventListener('click', (e) => {
			const link = e.target.closest('a[rel="scroll"]');
			if (!link || !link.hash) return;
			openAccordion(link.hash.slice(1));
		}, true);
	};

	// ＝＝＝＝ ↑↑ FUNCTIONS ↑↑ ＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝

	const familychallengeFUNCTIONS = () => {
		familyChallengeTab();
		familyChallengeAccordionHash();
	};

	(FUNCTIONS.localDecision()) ? document.addEventListener('localincludeLoaded', () => { familychallengeFUNCTIONS(); }) : familychallengeFUNCTIONS();

})(window.FUNCTIONS);
